import React, {Component} from "react";

class SidebarMinimizer extends Component {
    constructor(){
        super();
        this.sidebarMinimize = this.sidebarMinimize.bind(this);
        this.brandMinimize = this.brandMinimize.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    sidebarMinimize() {
        document.body.classList.toggle("sidebar-minimized");
    }

    brandMinimize() {
        document.body.classList.toggle("brand-minimized");
    }

    handleClick(){
        this.sidebarMinimize();
        this.brandMinimize();
    }

    render() {
        return (
            <button className="sidebar-minimizer" type="button" onClick={this.handleClick}></button>
        );
    }
}

export default SidebarMinimizer;



// WEBPACK FOOTER //
// ./src/components/SidebarMinimizer/SidebarMinimizer.js